import { Action, Reducer, Dispatch } from 'redux';
import InstanceClient from '../services/InstanceClient';
import StatusCode from '../util/StatusCode';
import { CorePasswordProfile, CoreWordList, FormPasswordProfile } from '../models/CorePasswordProfileModels';
import { CacheRequestState, EmptyRequestState, RequestState } from '../models/RequestState';


export enum PasswordProfileType {
    LIST_PASSWORD_PROFILES = 'LIST_PASSWORD_PROFILES',
    LIST_PASSWORD_PROFILES_UPDATE = 'LIST_PASSWORD_PROFILES_UPDATE',
    UPDATE_PASSWORD_PROFILE = 'UPDATE_PASSWORD_PROFILE',
    LIST_WORDLISTS = 'LIST_WORDLISTS',
}

export interface PasswordProfileState {
    passwordProfiles: CacheRequestState<CorePasswordProfile[]>
    updatePasswordProfile: EmptyRequestState
    wordLists: RequestState<CoreWordList[]>
}

interface ListPasswordProfilesAction extends Action<PasswordProfileType.LIST_PASSWORD_PROFILES> {
    passwordProfiles: CacheRequestState<CorePasswordProfile[]>
}
interface UpdatePasswordProfilesAction extends Action<PasswordProfileType.UPDATE_PASSWORD_PROFILE> {
    updatePasswordProfile: EmptyRequestState
}
interface ListWordListsAction extends Action<PasswordProfileType.LIST_WORDLISTS> {
    wordLists: RequestState<CoreWordList[]>
}
interface ListPasswordProfilesUpdateAction extends Action<PasswordProfileType.LIST_PASSWORD_PROFILES_UPDATE> { }

type PasswordProfileAction = ListPasswordProfilesAction
    | UpdatePasswordProfilesAction
    | ListPasswordProfilesUpdateAction
    | ListWordListsAction;

export const ListPasswordProfiles = (update: boolean = false) => (dispatch: Dispatch<PasswordProfileAction>) => {
    if (update) {
        dispatch({
            type: PasswordProfileType.LIST_PASSWORD_PROFILES_UPDATE,
        })
    } else {
        dispatch({
            type: PasswordProfileType.LIST_PASSWORD_PROFILES,
            passwordProfiles: { code: StatusCode.PENDING }
        })
    }

    InstanceClient.get<CorePasswordProfile[]>('/api/core/passwordprofiles')
        .then(res =>
            dispatch({
                type: PasswordProfileType.LIST_PASSWORD_PROFILES,
                passwordProfiles: { code: StatusCode.COMPLETE, data: res.data }
            }))
        .catch(error =>
            dispatch({
                type: PasswordProfileType.LIST_PASSWORD_PROFILES,
                passwordProfiles: { code: StatusCode.ERROR, error }
            }));
}

export const UpdatePasswordProfile = (profile: FormPasswordProfile) => (dispatch: Dispatch<PasswordProfileAction>) => {
    dispatch({
        type: PasswordProfileType.UPDATE_PASSWORD_PROFILE,
        updatePasswordProfile: { code: StatusCode.PENDING }
    })

    InstanceClient.put('/api/core/passwordprofiles', profile)
        .then(res =>
            dispatch({
                type: PasswordProfileType.UPDATE_PASSWORD_PROFILE,
                updatePasswordProfile: { code: StatusCode.COMPLETE }
            }))
        .catch(error =>
            dispatch({
                type: PasswordProfileType.UPDATE_PASSWORD_PROFILE,
                updatePasswordProfile: { code: StatusCode.ERROR, error }
            }));
}

export const ClearUpdatePasswordProfile = () => (dispatch: Dispatch<PasswordProfileAction>) => {
    dispatch({
        type: PasswordProfileType.UPDATE_PASSWORD_PROFILE,
        updatePasswordProfile: { code: StatusCode.NONE }
    })
}

export const DeletePasswordProfile = (id: string) => (dispatch: Dispatch<PasswordProfileAction>) => {
    dispatch({
        type: PasswordProfileType.UPDATE_PASSWORD_PROFILE,
        updatePasswordProfile: { code: StatusCode.PENDING }
    })

    InstanceClient.delete(`api/core/passwordprofiles/${id}`)
        .then(res =>
            dispatch({
                type: PasswordProfileType.UPDATE_PASSWORD_PROFILE,
                updatePasswordProfile: { code: StatusCode.COMPLETE }
            }))
        .catch(error =>
            dispatch({
                type: PasswordProfileType.UPDATE_PASSWORD_PROFILE,
                updatePasswordProfile: { code: StatusCode.ERROR, error }
            }));
}

export const ListWordLists = () => (dispatch: Dispatch<PasswordProfileAction>) => {
    dispatch({
        type: PasswordProfileType.LIST_WORDLISTS,
        wordLists: { code: StatusCode.PENDING }
    })

    InstanceClient.get<CoreWordList[]>('/api/core/passwordprofiles/wordLists')
        .then(res =>
            dispatch({
                type: PasswordProfileType.LIST_WORDLISTS,
                wordLists: { code: StatusCode.COMPLETE, data: res.data }
            }))
        .catch(error =>
            dispatch({
                type: PasswordProfileType.LIST_WORDLISTS,
                wordLists: { code: StatusCode.ERROR, error }
            }));
}

const initialState: PasswordProfileState = {
    passwordProfiles: { code: StatusCode.NONE },
    updatePasswordProfile: { code: StatusCode.NONE },
    wordLists: { code: StatusCode.NONE },
}

export const reducer: Reducer<PasswordProfileState, PasswordProfileAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case PasswordProfileType.LIST_PASSWORD_PROFILES:
            return {
                ...state,
                passwordProfiles: action.passwordProfiles
            };
        case PasswordProfileType.LIST_PASSWORD_PROFILES_UPDATE:
            return {
                ...state,
                passwordProfiles: { ...state.passwordProfiles, code: StatusCode.PENDING }
            };
        case PasswordProfileType.UPDATE_PASSWORD_PROFILE:
            return {
                ...state,
                updatePasswordProfile: action.updatePasswordProfile
            };
        case PasswordProfileType.LIST_WORDLISTS:
            return {
                ...state,
                wordLists: action.wordLists
            };
        default:
            return state;
    }
}